var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"loading-ball text-xs-center mt-3",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('line-scale-loader',{attrs:{"color":"#C2C2C2","size":"60px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }